import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/epicodds/images/logo/logoFooter.png';

export default function index() {
  return <Image src={footerLogo} maxW="222px" />;
}
